/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Пункт `Избранное` выпадающего меню каталога.
   */
  app.WishTabCatalogMenu = app.View.extend({
    'el': '[data-submenu-id=\'id_fav\']',
    events: {
      'click': 'toggleTab'
    },
    
    toggleTab: function () {
      $.ajax({
        url: app.entryScriptName + '/catalog-menu/wish/',
        data: {
          'currency': app.helpers.UrlHelper.getUrlParameter('currency'),
          'sort': app.helpers.UrlHelper.getUrlParameter('sort'),
          'per-page': app.helpers.UrlHelper.getUrlParameter('per-page')
        },
        ifModified: true,
        success: function (data) {
          // @todo: перейти на тыбы и изолировать элементы
          $('#id_fav .catalog-popup-layer').html(data);
        }
      });
    }
  });
  
})(jQuery);

}.call(window));